import { Geometry } from "geojson";
// import { FirestoreInventoryItemProps } from "types/auth";
import { CategoriesFilterLogicType } from "types/mapData";

// These categories describe the source or geometry of a public feature, not
// a visitor-facing subject. They remain on the feature data, but are not
// offered as audience-map filters.
export const AUDIENCE_FILTER_HIDDEN_CATEGORIES = [
  "forest",
  "nature",
  "other",
  "polygons",
  "lines",
  "points",
  "notes",
  "audience",
] as const;

type CategoriesFilterCheckProps = {
  categories: string[];
  featureType?: Geometry["type"];// | FirestoreInventoryItemProps["inventoryType"];
  featureCategories: string[];
  logic: CategoriesFilterLogicType;
  ignoredCategories?: readonly string[];
};
export function categoriesFilterCheck({
  categories,
  featureType,
  featureCategories,
  logic,
  ignoredCategories,
}: CategoriesFilterCheckProps) {
  // Input checking
  if (featureType === "GeometryCollection") return false;
  let catCheckArray: string[] = [];
  if (featureType) {
    if (["Point", "MultiPoint"].includes(featureType)) catCheckArray.push("points");
    if (["LineString", "MultiLineString"].includes(featureType)) catCheckArray.push("lines");
    if (["Polygon", "MultiPolygon"].includes(featureType)) catCheckArray.push("polygons");
  }
  // Check if feature has categories and extract
  // Add feature type to check array
  catCheckArray = [...catCheckArray, ...featureCategories];
  if (ignoredCategories) {
    catCheckArray = catCheckArray.filter((category) => !ignoredCategories.includes(category));
    // A feature with no audience-filterable category must remain reachable;
    // otherwise a visitor could hide it without any way to restore it.
    if (!catCheckArray.length) return true;
  }
  // Apply filter logic
  if (logic === "AND") {
    if (catCheckArray.every((cat: string) => categories.includes(cat))) {
      return true;
    }
  } else if (logic === "OR") {
    if (categories.some((cat) => catCheckArray.includes(cat))) {
      return true;
    }
  }
  return false;
}
